import { http } from '../http-common';
import {
  CalendarEvent,
  CalendarEventListParams,
  CalendarEventPage,
  CalendarEventRequest,
} from '../types/CalendarEvent';

const getAll = (params: CalendarEventListParams) =>
  http.get<CalendarEventPage>('/calendar-events', { params });

const get = (id: number) => http.get<CalendarEvent>(`/calendar-events/${id}`);

const create = (data: CalendarEventRequest) =>
  http.post<CalendarEvent>('/calendar-events', data);

const update = (id: number, data: CalendarEventRequest) =>
  http.patch<CalendarEvent>(`/calendar-events/${id}`, data);

const remove = (id: number) => http.delete<void>(`/calendar-events/${id}`);

const CalendarEventService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default CalendarEventService;
